import { render, staticRenderFns } from "./PrivateClasses.vue?vue&type=template&id=0f60dd24"
import script from "./PrivateClasses.vue?vue&type=script&lang=js"
export * from "./PrivateClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports